// Application version - update this when pushing significant changes
export const VERSION = '1.13.8'; // Re-enable check detection // Persistent database with Railway volume
